import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
export default function AdvancedSearchModal({ openModal, onClose }) {
  const handleCloseModal = () => {
    onClose();
  };
  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      event.stopPropagation();
    }
  };
  return (
    <>
      <Dialog
        open={openModal}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
        onClick={handleBackdropClick}
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            fontSize: "20px",
            color: "rgba(1, 1, 2, 0.92)",
            fontFamily: "Poppins",
          }}
        >
          Advanced Search
          <IconButton
            aria-label="close"
            onClick={() => handleCloseModal()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "#000000",
            }}
          >
            <RxCross2 />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className="row">
            <div className="col-6">
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "rgba(1, 1, 2, 0.6)",
                  fontFamily: "Poppins",
                }}
              >
                Customer Name
              </Typography>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                placeholder="Enter parameter"
              />
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "rgba(1, 1, 2, 0.6)",
                  fontFamily: "Poppins",
                  marginTop: "16px",
                }}
              >
                Email Address
              </Typography>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                placeholder="Enter parameter"
              />
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "rgba(1, 1, 2, 0.6)",
                  fontFamily: "Poppins",
                  marginTop: "16px",
                }}
              >
                Resaon Code
              </Typography>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                placeholder="Enter parameter"
              />
            </div>

            <div className="col-6">
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "rgba(1, 1, 2, 0.6)",
                  fontFamily: "Poppins",
                }}
              >
                Mobile Number
              </Typography>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                placeholder="Enter parameter"
              />
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "rgba(1, 1, 2, 0.6)",
                  fontFamily: "Poppins",
                  marginTop: "16px",
                }}
              >
                Legal Entity
              </Typography>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                placeholder="Enter parameter"
              />
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "rgba(1, 1, 2, 0.6)",
                  fontFamily: "Poppins",
                  marginTop: "16px",
                }}
              >
                Customer ID
              </Typography>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                placeholder="Enter parameter"
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions style={{ paddingBottom: "15px" }}>
          <Button
            variant="outlined"
            style={{
              color: "rgba(36, 183, 170, 1)",
              marginRight: "10px",
              textTransform: "none",
              fontSize: "20px",
              width: "210px",
              height: "48px",
              fontWeight: 600,
              borderRadius: "8px",
              border: "2px solid",
              fontFamily: "Poppins",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              fontWeight: 600,
              backgroundColor: "#24B7AA",
              borderRadius: "8px",
              textTransform: "none",
              marginRight: "10px",
              width: "236px",
              fontSize: "18px",
              width: "210px",
              height: "48px",
              fontFamily: "Poppins",
            }}
          >
            Search
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
